/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProgramChannelProvider,
    ProgramChannelProviderFromJSON,
    ProgramChannelProviderFromJSONTyped,
    ProgramChannelProviderToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateProgramChannelProviderRequest
 */
export interface CreateProgramChannelProviderRequest {
    /**
     * 
     * @type {ProgramChannelProvider}
     * @memberof CreateProgramChannelProviderRequest
     */
    programChannelProvider: ProgramChannelProvider;
}

export function CreateProgramChannelProviderRequestFromJSON(json: any): CreateProgramChannelProviderRequest {
    return CreateProgramChannelProviderRequestFromJSONTyped(json, false);
}

export function CreateProgramChannelProviderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateProgramChannelProviderRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'programChannelProvider': ProgramChannelProviderFromJSON(json['program_channel_provider']),
    };
}

export function CreateProgramChannelProviderRequestToJSON(value?: CreateProgramChannelProviderRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'program_channel_provider': ProgramChannelProviderToJSON(value.programChannelProvider),
    };
}


